// SMS phone verification (Twilio OTP send/verify) is on hold while the
// business decides whether SMS engagement is worth the Twilio cost. Every
// phone-capture flow below still collects and saves the phone number, it
// just skips the send-code/verify-code round trip. Flip back to true once
// a Twilio plan is active again.
export const SMS_PHONE_VERIFICATION_ENABLED = false
